const siteList = (state) => state.siteList;
const serviceProviderList = (state) => state.serviceProviderList;
const rateList = (state) => state.rateList;
const siteDetails = (state) => state.siteDetails;
const siteForEdit = (state) => state.siteForEdit;

export default {
  siteList,
  siteDetails,
  rateList,
  serviceProviderList,
  siteForEdit
}


// WEBPACK FOOTER //
// ./src/store/modules/siteManagement/getters.js